import { memo, useEffect, useState } from "react";
import AuthorGroup from "../FrontMatter/AuthorGroup";
import Affiliations from "../FrontMatter/Affiliations";
import Keyword from "../FrontMatter/Keyword";

const MetaData = ({
  rightPanelvalue,
  rightPanelOpen,
  editor,
  RightPanelClose,
  metaValue,
  setShowFMatter,
}) => {
  const [isOpen, setIsOpen] = useState(null);

  const handleOpen = (id) => {
    setIsOpen((prev) => {
      if (prev === id) {
        setShowFMatter({
          authorgrouping: false,
          affiliation: false,
          keywords: false,
        });
        return null;
      } else {
        return id;
      }
    });
  };

  useEffect(() => {
    setIsOpen(metaValue);
  }, [metaValue]);

  const Panel = ({ id, title, children }) => (
    <div className="transition-all duration-300 linear border border-grey rounded-xl ">
      <div
        onClick={() => handleOpen(id)}
        className={`bg-hovergrey text-[16px] text-white font-semibold flex justify-between py-2 px-[6px] rounded-lg items-center cursor-pointer`}
      >
        <p className="text-white font-semibold text-[16px]">{title}</p>
        <span className={`${isOpen === id ? "rotate-180" : ""} text-white`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </span>
      </div>
      <div
        className={`py-3 px-[6px] transition-all duration-300 linear  ${
          isOpen === id ? "max-h-fit block" : "max-h-0 hidden"
        }`}
      >
        {children}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col w-full h-full gap-5 ">
      <div className="border-b border-grey absolute top-0 bg-leftPanelbg inset-x-0 z-[10] p-3 ">
        <h4 className="font-semibold text-[18px] text-primary">MetaData</h4>
      </div>
      <div className="flex flex-col gap-5 mt-14">
        <Panel id="author" title="Contributors">
          <AuthorGroup
            isShow={rightPanelvalue}
            isOpen={rightPanelOpen}
            editor={editor}
            setIsOpen={setIsOpen}
            setShowFMatter={setShowFMatter}
          />
        </Panel>

        <Panel id="aff" title="Affiliation">
          <Affiliations
            editor={editor}
            setIsOpen={setIsOpen}
            setShowFMatter={setShowFMatter}
          />
        </Panel>
        <Panel id="keyword" title="Keywords">
          <Keyword
            editor={editor}
            setIsOpen={setIsOpen}
            setShowFMatter={setShowFMatter}
          />
        </Panel>
      </div>
    </div>
  );
};

export default memo(MetaData, (prevProps, nextProps) => {
  return (
    prevProps.rightPanelvalue === nextProps.rightPanelvalue &&
    prevProps.metaValue === nextProps.metaValue &&
    prevProps.rightPanelOpen === nextProps.rightPanelOpen &&
    prevProps.setShowFMatter === nextProps.setShowFMatter
  );
});
